import { getAgencyApiHost } from 'api/host-by-env';
import { PolicyUploadMapper } from 'features/services/policyupload/policyUpload.mapper';
import {
  DeleteDocumentRequest,
  GetPolicyUploadHistoryRequest,
  GetPolicyUploadHistoryResponse,
  PolicyUploadData,
  PolicyUploadResponse,
  ViewDocumentRequest,
  ViewDocumentResponse,
} from 'features/services/policyupload/type';
import { handleBusinessError, handleError } from 'utilities/utilities';

export async function postPolicyUpload(payload: PolicyUploadData, token: string): Promise<PolicyUploadResponse> {
  const url = `${getAgencyApiHost()}policy-upload/v1/images`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.Result;
}

export async function deletePolicyUpload(payload: DeleteDocumentRequest, token: string): Promise<boolean> {
  const encodedDocumentKey = encodeURIComponent(payload.DocumentKey);

  const url = `${getAgencyApiHost()}policy-upload/v1/images?DocumentKey=${encodedDocumentKey}&firmId=${payload.FirmId}`;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.Result;
}

export async function getHistory(
  payload: GetPolicyUploadHistoryRequest,
  token: string,
): Promise<GetPolicyUploadHistoryResponse[]> {
  let url = `${getAgencyApiHost()}policy-upload/v1/history?FirmId=${payload.firmId}`;
  if (payload.fromDate) {
    url += `&DateFrom=${encodeURIComponent(payload.fromDate)}`;
  }
  if (payload.toDate) {
    url += `&DateTo=${encodeURIComponent(payload.toDate)}`;
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return PolicyUploadMapper.getPolicyUploadHistory(json.Result);
}

export async function getDocument(payload: ViewDocumentRequest, token: string): Promise<ViewDocumentResponse> {
  const encodedFileName = encodeURIComponent(payload.FileName);

  const url = `${getAgencyApiHost()}policy-upload/v1/images?FileName=${encodedFileName}&InRPS=${payload.InRPS}&FirmId=${
    payload.FirmId
  }`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.Result;
}
